/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';

export const isSessionDuplicate = error => R.hasPath(['data', 'message'], error)
&& R.pathSatisfies(R.includes('duplicate'), ['data', 'message'], error);

export const isSessionExpiring = (nowTs, createdTs) =>
  (nowTs - createdTs) / 1000 / 60 / 60 / 24 > 25;
